{
	"title": "Deklarationer",
	"table": {
		"material": "Material",
		"dateOfIssue": "Utfärdandedatum",
		"quantity": "Kvantitet",
		"carbonSavings": "Koldioxidreduktioner",
		"status": {
			"title": "Status",
			"TransactionProcessing": "Transaktionen behandlas",
			"CreatingDeclaration": "Skapar deklaration",
			"GenerationFailed": "Genereringen misslyckades",
			"ReadyToDownload": "Redo att ladda ner"
		}
	},
	"declarationLanguageSelect": {
		"title": "Deklarationsspråk",
		"description": "Välj ett språk för deklarationen.",
		"label": "Deklarationsspråk",
		"buttonBack": "Tillbaka",
		"buttonSave": "Spara"
	},
	"downloadAllLanguageSelect": {
		"title": "Deklarationsspråk",
		"descriptionGlobal": "Välj ett språk för alla deklarationer.",
		"descriptionIndividual": "Eller ställ in språket för varje deklaration individuellt.",
		"label": "Deklarationsspråk",
		"tableHeaderDeclaration": "Deklaration (material/utfärdandedatum)",
		"tableHeaderLanguage": "Deklarationsspråk",
		"buttonBack": "Tillbaka",
		"buttonDownload": "Ladda ner deklarationer"
	},
	"declarationActions": {
		"changeLanguage": "Ändra deklarationsspråk",
		"preview": "Förhandsgranska",
		"download": "Ladda ner",
		"transaction": "Transaktion",
		"showMoreTransactions": "Visa fler transaktioner",
		"languageLabel": "Deklarationsspråk",
		"downloadAll": "Ladda ner alla deklarationer"
	}
}
